<h1 class="font-brand text-28px font-bold text-neutral-800">
  {{ step().title }}
</h1>
<app-kiosk-horizontal-scroll
  [leftButtonTemplate]="leftButton"
  [rightButtonTemplate]="rightButton"
  [contentTemplate]="content"
  #horizontalScroll
>
  <ng-template #leftButton>
    @let leftButtonData = horizontalScroll.leftButtonData;
    <app-button-atom
      size="S"
      color="neutral"
      [icon]="'icon-arrow-down-s'"
      [iconRotation]="'180'"
      type="kiosk-light"
      thickSize="S"
      [full]="false"
      [aspectSquare]="true"
      [disabled]="leftButtonData().disabled"
    ></app-button-atom>
  </ng-template>

  <ng-template #rightButton>
    @let rightButtonData = horizontalScroll.rightButtonData;
    <app-button-atom
      size="S"
      color="neutral"
      [icon]="'icon-arrow-down-s'"
      [iconRotation]="'270'"
      type="kiosk-light"
      thickSize="S"
      [full]="false"
      [disabled]="rightButtonData().disabled"
      [aspectSquare]="true"
    ></app-button-atom>
  </ng-template>

  <ng-template #content>
    @if (productsQuery.hasValue()) {
      <div class="max-width-full flex flex-row">
        @for (product of productsQuery.value(); track product.id) {
          <div class="snap-center">
            <div
              class="mr-3 w-10 min-w-10 flex-shrink-0 flex-grow-0 md:mr-4 lg:mr-6 lg:w-52 lg:min-w-52 xl:mr-8"
            >
              <app-product-card-atom
                displayContext="loyalty"
                [product]="product"
                [isOrderingAllowed]="true"
                (productClick)="onNavigateTo(product)"
              ></app-product-card-atom>
            </div>
          </div>
        }
      </div>
    }
  </ng-template>
</app-kiosk-horizontal-scroll>

@if (!productsQuery.isLoading() && productsQuery.value()?.length === 0) {
  <div class="py-4">
    {{ 'zerosix.offered-product-modal.no-product-available' | translate }}
  </div>
}

@if (productsQuery.isLoading()) {
  <div class="w-full py-4 text-center">
    <img
      src="assets/images/spinner.svg"
      alt=""
      class="mx-auto pr-2"
    />
  </div>
}
